import { render } from "./DiagnosisLogItem.vue?vue&type=template&id=016b07fc"
import script from "./DiagnosisLogItem.vue?vue&type=script&lang=js"
export * from "./DiagnosisLogItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__